export { default as queryInstance } from "./queryInstance";
